module.exports = __webpack_public_path__ + "media/images/design/images/dantai/IMG_1074-6e00720698d5f070c7a2a5cc95fa5106.JPG";